import React from "react";

import styles from "./TickerStatusMessage.module.css";
import { useTranslateMessage } from "~utils/i18n";
import type { TransformEntry } from "~types/i18n";

const TICKER_STATUS_MESSAGE_MAP: Record<string, TransformEntry> = {
  ACQU: { id: "wasAcquiredBy", defaultMessage: "was acquired by" },
  POST: { id: "isPostponed", defaultMessage: "is postponed" },
  PEND: { id: "isPending", defaultMessage: "is pending" },
  INAC: { id: "isInactive", defaultMessage: "is inactive" },
  TKCH: {
    id: "hasChangedToANewTickerSym",
    defaultMessage: "has changed to a new ticker symbol",
  },
  UNLS: { id: "isUnlisted", defaultMessage: "is unlisted" },
  LIQU: { id: "wasLiquidated", defaultMessage: "was liquidated" },
};

interface TickerStatusMessageProps {
  marketStatus: string;
  tickerId: string;
  ultimateParentTicker?: string;
  primarySecurityTicker?: string;
  issuerEquityTicker?: string;
}

export const TickerStatusMessage = ({
  marketStatus,
  tickerId,
  ultimateParentTicker,
  primarySecurityTicker,
  issuerEquityTicker,
}: TickerStatusMessageProps) => {
  const translateMessage = useTranslateMessage();
  const tickerLabelConfig = TICKER_STATUS_MESSAGE_MAP[marketStatus];

  const tickerMessage = tickerLabelConfig
    ? translateMessage({
        id: tickerLabelConfig.id,
        defaultMessage: tickerLabelConfig.defaultMessage,
      })
    : null;

  if (!tickerMessage) {
    return null;
  }

  const newTicker =
    issuerEquityTicker || primarySecurityTicker || ultimateParentTicker || "";
  const hasNewTicker = Boolean(newTicker);
  const isNewTicker = marketStatus === "ACQU" || marketStatus === "TKCH";
  const shouldRenderUltimateParentTickerLink = isNewTicker && hasNewTicker;
  const formattedNewTicker = newTicker.replace(" ", ":");

  return (
    <p className={styles.tickerMessage}>
      {tickerId} {tickerMessage}
      {shouldRenderUltimateParentTickerLink && (
        <>
          {": "}
          <a href={`/quote/${formattedNewTicker}`}>{formattedNewTicker}</a>
        </>
      )}
    </p>
  );
};
